import { getAppList, GetAppListQuery, graphqlCall } from '@akin-home/amplify';
import { QueryClient, useQuery } from 'react-query';
import { built_in_apps } from '../data/built_in_apps';
import { AppCategory, AppRecord } from '../types';
import { sortByTextAttribute } from './../../utils/sorting';

interface ListAppsQueryResponse {
  statusCode: number;
  body: {
    apps: AppRecord[];
    categories: AppCategory[];
  };
}

/** Fetches app list from remote source */
const listAppsQuery = async () => graphqlCall<GetAppListQuery>(getAppList);

const parseGetAppListQuery = (query?: GetAppListQuery) => {
  if (!query?.getAppList) return { apps: [], categories: [] };

  const { body } = JSON.parse(query.getAppList) as ListAppsQueryResponse;

  const apps = [...(body?.apps || []), ...built_in_apps];

  return {
    apps: apps.sort(sortByTextAttribute('label')),
    categories: body?.categories.sort(sortByTextAttribute('label')) || [],
  };
};

export const listAndParseAppsQuery = async () =>
  parseGetAppListQuery((await listAppsQuery()).data);

export const useListAppsQuery = () => {
  /** Refetch apps every hour */
  const { data, ...results } = useQuery('apps', listAndParseAppsQuery, {
    refetchInterval: 1000 * 60 * 60,
  });

  return {
    ...results,
    apps: data?.apps || [],
    categories: data?.categories || [],
  };
};

/** Apps take a while to load, so best to prefetch them at some point */
export const prefetchApps = async (queryClient: QueryClient) => {
  await queryClient.prefetchQuery('apps', listAndParseAppsQuery);
};
